class Step {
    constructor(xDimensions, //  e.g. [0.5, 2]  (0..4 = first bar)
    yDimensions, // e.g. [0, 0.5]  (0..1 = full sample)
    startClosed = false, endClosed = false) {
        this.xDimensions = xDimensions;
        this.yDimensions = yDimensions;
        this.startClosed = startClosed;
        this.endClosed = endClosed;
    }
    get startX() { return this.xDimensions[0]; }
    get startY() { return this.yDimensions[0]; }
    get endX() { return this.xDimensions[1]; }
    get endY() { return this.yDimensions[1]; }
    /**
     * x value length (in normalized beats, not seconds)
     */
    get length() {
        return this.xDimensions[1] - this.xDimensions[0];
    }
    clone() {
        let stepClone = new Step(this.xDimensions, this.yDimensions, this.startClosed, this.endClosed);
        return stepClone;
    }
}
class PauseStep extends Step {
    clone() {
        let stepClone = new PauseStep(this.xDimensions, this.yDimensions, this.startClosed, this.endClosed);
        return stepClone;
    }
}
export default Step;
export { Step, PauseStep, };
